import { Link, useLocation } from "react-router-dom";

import "./style.scss";

const SIDE_BAR_LINKS = [
  {
    name: "Home",
    to: "/",
  },
  {
    name: "About Us",
    to: "/about",
  },
  // {
  //   name: "Methodology",
  //   to: "/methodology",
  // },
  {
    name: "Calculator",
    to: "/calculator",
  },
  {
    name: "Case Studies",
    to: "/case-studies",
  },
  {
    name: "FAQ",
    to: "/faq",
  },
  {
    name: "Terms And Conditions",
    to: "/terms-and-conditions",
  },
  {
    name: "Contact",
    to: "/contact",
  },
];

const Sidebar = ({ isSidebarOpen, setIsSidebarOpen }) => {
  const location = useLocation();

  return (
    <div
      className={`sidebar-container ${!isSidebarOpen ? "closed-sidebar" : ""}`}
    >
      <div
        className="close-container"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        <div className="left-bar"></div>
        <div className="right-bar"></div>
      </div>
      <div className="sidebar-links-container">
        {SIDE_BAR_LINKS.map((link) => (
          <Link
            key={link.name}
            to={link.to}
            className={`sidebar-link ${
              location.pathname === link.to ? "active" : ""
            }`}
            onClick={() => setIsSidebarOpen(!isSidebarOpen)}
          >
            {link.name}
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;
